unit SpecialismListType;

interface

uses
  SpecialismType;

type
  TSpecialismListType = array of TSpecialismType;

implementation

end.
